import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { BidderService } from 'src/app/services/bidder.service';

@Component({
    selector: 'app-auction-info',
    templateUrl: './auction-info.component.html',
    styleUrls: ['./auction-info.component.css'],
    standalone: false
})
export class AuctionInfoComponent implements OnInit {
  panelOpenState = false;
  auctionVehicleInfo;

  @Output() closeModal = new EventEmitter<void>();
  @Input() auctionDateId: any;
  @Input() isModal: boolean = true;


  constructor(
    private _bidderService: BidderService,
    private alertService: AlertService) { 

  }

  ngOnInit(): void {
    this._bidderService.getAuctionInformation(this.auctionDateId)
    .subscribe(data => {
      this.auctionVehicleInfo = data;
    },
    error => {
      this.alertService.showError(error);
    });
  }

  closeAuctionInfoModal(){
    this.closeModal.emit();
  }

 public getColumnItems(item: any, column: 'left' | 'right'): any[] {
    const keys = Object.keys(item);
    const midIndex = Math.ceil(keys.length / 2);
    if (column === 'left') {
      return keys.slice(0, midIndex).map(key => ({ key: key, value: item[key] }));
    } else {
      return keys.slice(midIndex).map(key => ({ key: key, value: item[key] }));
    }
  }

  public addSpaceAfterCapitalizedLetters(input: string): string {
    return input.replace(/([A-Z])/g, ' $1');
  }

}
